module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/oliwia-bernat-f5b574e96d6e46e6a5558d62799f18e7.webp";